import {
  DefenseEventTypes,
  DefenseZoneFaultStatusTypes,
  IDefenseEventNotifyZoneFaultStatusProps,
} from '../../../../services/Defense/Events/types';
import TableComponent, {
  IColumnProps,
} from '../../../../components/TableComponent';
import { Grid2 } from '@mui/material';
import TextFieldComponent from '../../../../components/TextFieldComponent';
import {
  convertEventType,
  convertZoneFaultStatus,
} from '../../../../converters/Defense/ConverterDefense';
import React from 'react';

interface IDefenseNotifyZoneFaultStatusContentProps {
  event: IDefenseEventNotifyZoneFaultStatusProps;
}

const DefenseNotifyZoneFaultStatusContent = ({
  event,
}: IDefenseNotifyZoneFaultStatusContentProps) => {
  const columns: IColumnProps[] = [
    {
      id: 'id',
      label: 'ID',
      width: 'auto',
    },
    {
      id: 'device.id',
      label: 'ID do Dispositivo',
      width: 'auto',
    },
    {
      id: 'device.name',
      label: 'Nome do Dispositivo',
      width: 'auto',
    },
    {
      id: 'zoneId',
      label: 'ID de Zona',
      width: 'auto',
    },
    {
      id: 'faultStatus',
      label: 'Status',
      width: 'auto',
      render: (faultStatus: string) => {
        return (
          <>
            {convertZoneFaultStatus(faultStatus as DefenseZoneFaultStatusTypes)}
          </>
        );
      },
    },
  ];

  const getFormatedDate = (date: Date) => {
    return new Date(date.toLocaleString('pt-BR'));
  };

  return (
    <Grid2
      container
      direction="row"
      spacing={2}
      justifyContent={'center'}
      alignItems={'center'}
      size={12}
    >
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <TextFieldComponent
          label="Dispositivo"
          value={event?.device?.name ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Tipo"
          value={
            convertEventType(event.type as DefenseEventTypes) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 6 }} mb={3}>
        <TextFieldComponent
          label="Data/Hora"
          value={getFormatedDate(event.createdAt) ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Descrição"
          value={event.description ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          multiline
        />
      </Grid2>
      <TableComponent title={'Zonas'} rows={event.zones} columns={columns} />
    </Grid2>
  );
};

export default DefenseNotifyZoneFaultStatusContent;
